import type { SVGProps } from "react";
const SvgHotel01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 4v16c0 .943 0 1.414.293 1.707S4.057 22 5 22h14c.943 0 1.414 0 1.707-.293S21 20.943 21 20V4M10.5 8v1.5m0 1.5V9.5m3-1.5v1.5m0 1.5V9.5m-3 0h3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14 22v-4a2 2 0 1 0-4 0v4M2 4h6c.64-1.173 2.19-2 4-2s3.36.827 4 2h6M6 8h1m-1 4h1m-1 4h1M17 8h1m-1 4h1m-1 4h1"
    />
  </svg>
);
export default SvgHotel01;
